var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('recebimento-dados-nivel-2-agrupado',{ref:"nivel_2_cards",attrs:{"objeto-acao":_vm.objetoAcao}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }